import axios from "axios";
export function getAuthenticationHeaderValue(token) {
    return `Bearer ${token}`;
}
export function createRestClientInstance({ baseURL }) {
    const config = {
        baseURL,
    };
    return axios.create(config);
}
export function addRenewTokenMethodToAxiosInstance(axiosInstance, auth) {
    axiosInstance.refreshTokens = auth.refreshTokens.bind(auth);
}
export function applyAuthenticationInterceptor(axios, auth) {
    const onRequestResolve = (config) => {
        if (!config.notAuthenticated && auth.tokens.access) {
            Object.assign(config.headers, {
                Authorization: getAuthenticationHeaderValue(auth.tokens.access.encoded),
            });
        }
        return config;
    };
    const onRequestReject = (error) => Promise.reject(error);
    axios.interceptors.request.use(onRequestResolve, onRequestReject);
    const onResponseResolve = (data) => Promise.resolve(data);
    const onResponseReject = (error) => {
        if (error.response && error.response.status === 401) {
            const originalRequest = error.config;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if (!originalRequest.__disableTokensRefreshing) {
                return auth
                    .refreshTokens()
                    .then(() => {
                    return axios.request({
                        ...originalRequest,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-expect-error
                        __disableTokensRefreshing: true,
                    });
                })
                    .catch((e) => Promise.reject(e));
            }
            // auth.logout();
        }
        return Promise.reject(error);
    };
    axios.interceptors.response.use(onResponseResolve, onResponseReject);
}
